import type { AxiosInstance } from 'axios';

import { MissingMediaModuleClientError } from './errors';

let mediaModuleAxiosInstance: AxiosInstance | null = null;

export const registerMediaModuleAxiosInstance = ({ instance }: { instance: AxiosInstance }) => {
  mediaModuleAxiosInstance = instance;
};

export const getMediaModuleAxiosInstance = (): AxiosInstance => {
  if (!mediaModuleAxiosInstance) {
    throw new MissingMediaModuleClientError();
  }

  return mediaModuleAxiosInstance;
};
